import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div id='contact' className="enquiry-main">
      <div className="enquiry-container">
        
        {/* LEFT SIDE IMAGE */}
        <div className="enquiry-image-side" data-aos="fade-right">
          {/* <div className="overlay">
          </div> */}
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="enquiry-form-side" data-aos="fade-left">
          <div className="form-wrapper">
            <h2 className='fontgeorgio'>Enquiry Form</h2>
            <form>
              <input type="text" placeholder="Full Name" required />
              <input type="email" placeholder="name@example.com" required />
              <input type="tel" placeholder="Phone Number" required />
              <input type="message" placeholder='Enter Your message'/>
              <button type="submit">Submit Enquiry</button>
            </form>
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default Contact;
